"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-toggle/style.css");
var _reactToggle = _interopRequireDefault(require("react-toggle"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputToggle = props => {
  let defaultValue = props.defaultValue;
  if (props.value !== null && props.value !== "") defaultValue = props.value;
  defaultValue = defaultValue === 1 || defaultValue === "1" || defaultValue === "true" || defaultValue === true;
  const changeValue = e => {
    let result = 1;
    if (e.target.checked === true) result = 1;
    if (e.target.checked === false) result = 0;
    props.onChange(result);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: "col-sm-12"
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_reactToggle.default, {
    name: props.name,
    defaultChecked: defaultValue,
    defaultValue: defaultValue,
    icons: false,
    onChange: changeValue
  })), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputToggle;
exports.default = _default;